export default __webpack_public_path__ + "static/media/phone.c1d8edf6.svg";